module.exports = __webpack_public_path__ + "static/media/part-return-slide-1.05873dde.jpg";